// smooth-scroll.js — Lenis smooth scrolling, desktop only.
// GSAP + ScrollTrigger are the animation stack for the whole site;
// register the plugin here so every later script can rely on it.
(function () {
    'use strict';

    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
    }

    if (!window.matchMedia('(min-width: 992px)').matches) return;
    if (typeof Lenis === 'undefined') return;

    var lenis = new Lenis({
        lerp: 0.1,
        smoothWheel: true
    });

    lenis.on('scroll', function () {
        if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.update();
        }
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    window.lenis = lenis;

    // smooth scroll to anchors with the fixed header offset
    document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href*="#"]');
        if (!link) return;
        var url;
        try {
            url = new URL(link.href, window.location.href);
        } catch (err) {
            return;
        }
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        if (!url.hash || url.hash === '#') return;
        var target = document.querySelector(url.hash);
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.js-header');
        var offset = header ? -(header.offsetHeight + 16) : 0;
        lenis.scrollTo(target, { offset: offset });
    });
}());
